export default __webpack_public_path__ + "static/media/coffe6.9c0a99d5.png";